import { render, staticRenderFns } from "./GenerateRotaWaitingList.vue?vue&type=template&id=8eeffc48"
import script from "./GenerateRotaWaitingList.vue?vue&type=script&lang=js"
export * from "./GenerateRotaWaitingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports